var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "get_order_sync" },
    [
      !_vm.show_feed
        ? _c(
            "div",
            { staticClass: "panel-container-org" },
            [
              _c(
                "b-overlay",
                {
                  key: "main_loader",
                  attrs: { show: !_vm.auth_obj.isLoaded, rounded: "sm" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "overlay",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              { staticClass: "text-center" },
                              [
                                _c("b-icon", {
                                  attrs: {
                                    icon: "stopwatch",
                                    "font-scale": "2",
                                    animation: "cylon",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { attrs: { id: "cancel-label" } },
                                  [
                                    _vm.auth_obj.isRunning
                                      ? _c(
                                          "b-badge",
                                          {
                                            attrs: {
                                              variant: "primary",
                                              pill: "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(_vm.auth_obj.step_name) +
                                                " : " +
                                                _vm._s(_vm.__t("TIME")) +
                                                " " +
                                                _vm._s(_vm.timer.seconds) +
                                                "\n                        "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    724123391
                  ),
                },
                [
                  _vm._v(" "),
                  _c("div", { staticClass: "work_area" }, [
                    _vm.auth_obj.token != null
                      ? _c("div", { staticClass: "panel-tag word-break" }, [
                          _vm._v(
                            "\n                    API info: " +
                              _vm._s(_vm.auth_obj.token) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.is_barsi_meal
                      ? _c("div", { staticClass: "feed_block_standart" }, [
                          _vm.cur_step == "orgs_loaded"
                            ? _c("h3", { staticClass: "pb-2" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.__t(
                                        _vm.provider.type.toUpperCase() +
                                          "_SELECT_ORG"
                                      )
                                    ) +
                                    "\n                    "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "lot_or" },
                            _vm._l(_vm.worked_orgs, function (org, idx) {
                              return _c(
                                "div",
                                { staticClass: "form-group mt-2 org_item" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "input-group input-group-lg",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group-prepend" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "input-group-text" },
                                            [
                                              _c("bounce-loader", {
                                                attrs: {
                                                  loading: org.is_loading,
                                                  size: "10px",
                                                },
                                              }),
                                              _vm._v(" "),
                                              !org.is_loading
                                                ? _c("i", {
                                                    staticClass:
                                                      "fal fa-building",
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "form-control" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "custom-control custom-checkbox",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: org.is_selected,
                                                    expression:
                                                      "org.is_selected",
                                                  },
                                                ],
                                                staticClass:
                                                  "custom-control-input",
                                                attrs: {
                                                  type: "checkbox",
                                                  disabled: org.is_loading,
                                                  id: org.id,
                                                },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    org.is_selected
                                                  )
                                                    ? _vm._i(
                                                        org.is_selected,
                                                        null
                                                      ) > -1
                                                    : org.is_selected,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.set_active_org(
                                                      org
                                                    )
                                                  },
                                                  change: function ($event) {
                                                    var $$a = org.is_selected,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          _vm.$set(
                                                            org,
                                                            "is_selected",
                                                            $$a.concat([$$v])
                                                          )
                                                      } else {
                                                        $$i > -1 &&
                                                          _vm.$set(
                                                            org,
                                                            "is_selected",
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              )
                                                          )
                                                      }
                                                    } else {
                                                      _vm.$set(
                                                        org,
                                                        "is_selected",
                                                        $$c
                                                      )
                                                    }
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "custom-control-label",
                                                  attrs: { for: org.id },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(org.title) +
                                                      "\n                                        "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "input-group-append" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: org.id,
                                                expression: "org.id",
                                              },
                                            ],
                                            staticClass: "text-center fs-xl",
                                            attrs: {
                                              type: "text",
                                              disabled: "",
                                            },
                                            domProps: { value: org.id },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  org,
                                                  "id",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _vm.has_external_menu
                            ? _c(
                                "div",
                                { staticClass: "external_params mt-3" },
                                [
                                  _c("h3", { staticClass: "pb-2" }, [
                                    _vm._v(
                                      "\n                           " +
                                        _vm._s(
                                          _vm.__t("POS.SELECT_EXTERNAL_MENU")
                                        ) +
                                        "\n                        "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-select", {
                                    attrs: {
                                      reduce: function (item) {
                                        return String(item.id)
                                      },
                                      label: "name",
                                      options: this.active_org.external_menu,
                                    },
                                    model: {
                                      value: _vm.externalMenuId,
                                      callback: function ($$v) {
                                        _vm.externalMenuId = $$v
                                      },
                                      expression: "externalMenuId",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.has_external_menu
                            ? _c(
                                "div",
                                { staticClass: "different_price_org pt-5" },
                                [
                                  _c("yes_no", {
                                    key: "DIFFERENT_PRICE_ON_SAME_MENU",
                                    attrs: {
                                      title: "DIFFERENT_PRICE_ON_SAME_MENU",
                                    },
                                    on: { input: _vm.on_set_different_prices },
                                    model: {
                                      value: _vm.show_diff_price,
                                      callback: function ($$v) {
                                        _vm.show_diff_price = $$v
                                      },
                                      expression: "show_diff_price",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-overlay",
                                    {
                                      key: "org_list_all",
                                      attrs: {
                                        show: _vm.is_load_all_org,
                                        rounded: "sm",
                                      },
                                    },
                                    _vm._l(
                                      _vm.draw_all_org,
                                      function (org, idx) {
                                        return _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form-group mt-2 org_item",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "input-group input-group-lg",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "input-group-prepend",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group-text",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fal fa-building",
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "form-control",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "custom-control custom-checkbox",
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                org.is_selected,
                                                              expression:
                                                                "org.is_selected",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "custom-control-input",
                                                          attrs: {
                                                            type: "checkbox",
                                                            id: "_" + org.id,
                                                          },
                                                          domProps: {
                                                            checked:
                                                              Array.isArray(
                                                                org.is_selected
                                                              )
                                                                ? _vm._i(
                                                                    org.is_selected,
                                                                    null
                                                                  ) > -1
                                                                : org.is_selected,
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              var $$a =
                                                                  org.is_selected,
                                                                $$el =
                                                                  $event.target,
                                                                $$c =
                                                                  $$el.checked
                                                                    ? true
                                                                    : false
                                                              if (
                                                                Array.isArray(
                                                                  $$a
                                                                )
                                                              ) {
                                                                var $$v = null,
                                                                  $$i = _vm._i(
                                                                    $$a,
                                                                    $$v
                                                                  )
                                                                if (
                                                                  $$el.checked
                                                                ) {
                                                                  $$i < 0 &&
                                                                    _vm.$set(
                                                                      org,
                                                                      "is_selected",
                                                                      $$a.concat(
                                                                        [$$v]
                                                                      )
                                                                    )
                                                                } else {
                                                                  $$i > -1 &&
                                                                    _vm.$set(
                                                                      org,
                                                                      "is_selected",
                                                                      $$a
                                                                        .slice(
                                                                          0,
                                                                          $$i
                                                                        )
                                                                        .concat(
                                                                          $$a.slice(
                                                                            $$i +
                                                                              1
                                                                          )
                                                                        )
                                                                    )
                                                                }
                                                              } else {
                                                                _vm.$set(
                                                                  org,
                                                                  "is_selected",
                                                                  $$c
                                                                )
                                                              }
                                                            },
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "custom-control-label",
                                                            attrs: {
                                                              for: "_" + org.id,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                " +
                                                                _vm._s(
                                                                  org.title
                                                                ) +
                                                                "\n                                            "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "input-group-append",
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: org.id,
                                                          expression: "org.id",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "text-center fs-xl",
                                                      attrs: {
                                                        type: "text",
                                                        disabled: "",
                                                      },
                                                      domProps: {
                                                        value: org.id,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            org,
                                                            "id",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ])
                      : _c(
                          "div",
                          { staticClass: "feed_barsi" },
                          [
                            _c("fileload", {
                              attrs: {
                                doc_id: _vm.prov_id,
                                doc_type: "feed",
                                url_load: "pos/upload/feed",
                              },
                              on: { finish_load: _vm.finish_load },
                            }),
                          ],
                          1
                        ),
                  ]),
                  _vm._v(" "),
                  !_vm.is_barsi_meal
                    ? _c("div", { staticClass: "buttons mt-5 pt-5" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-lg btn-outline-primary waves-effect waves-themed",
                            attrs: { disabled: _vm.can_sync },
                            on: { click: _vm.go_sync },
                          },
                          [
                            _c("span", {
                              staticClass: "fal",
                              class: {
                                "fa-check mr-1": !_vm.can_sync,
                                "fa-exclamation-triangle": _vm.can_sync,
                              },
                            }),
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.__t("CONTINUE")) +
                                "\n                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-lg btn-outline-warning waves-effect waves-themed ml-5",
                            attrs: { disabled: !_vm.can_sync },
                            on: { click: _vm.go_start },
                          },
                          [
                            _c("span", {
                              staticClass: "fal",
                              class: {
                                "fa-check mr-1": _vm.can_sync,
                                "fa-exclamation-triangle": !_vm.can_sync,
                              },
                            }),
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.__t("BACK")) +
                                "\n                "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.show_feed
        ? _c("pos_sync_feed", {
            attrs: {
              external_menu_id: _vm.external_menu_id,
              child_organizations: _vm.prices_orgs_ids,
              selected_org: _vm.active_org.uniq_id,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }